import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  carMakeValidatorRequired,
  carModelValidatorRequired,
  dateValidator,
  dateValidatorRequired,
  genericSelectValidatorRequired,
  registrationNumberValidatorRequired,
  textareaValidatorRequired,
  vinValidator,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.VEHICLE_OWNER_VEHICLE]: yup.object({
    [ComponentId.VEHICLE_TYPE]: genericSelectValidatorRequired,
    [ComponentId.REGISTRATION_NUMBER]: trimmedString.onlyIfFieldIsVisible(
      registrationNumberValidatorRequired
    ),
    [ComponentId.VIN]: trimmedString.onlyIfFieldIsVisible(vinValidator),
    [ComponentId.PRODUCTION_YEAR]: trimmedString.onlyIfFieldIsVisible(
      dateValidatorRequired
    ),
    [ComponentId.MAKE]: trimmedString.onlyIfFieldIsVisible(
      carMakeValidatorRequired
    ),
    [ComponentId.MODEL]: trimmedString.onlyIfFieldIsVisible(
      carModelValidatorRequired
    ),
    [ComponentId.REGISTRATION_DATE]: trimmedString.onlyIfFieldIsVisible(
      dateValidator
    ),
    [ComponentId.DESCRIPTION]: trimmedString.onlyIfFieldIsVisible(
      textareaValidatorRequired(100)
    ),
  }),
};
